'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const skeleton = require('../Skeleton/skeleton.js');
const headline_style = require('./headline.style.js');

var _excluded = ["level", "children", "isLoading", "theme"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Headline = function Headline(_ref) {
  var _ref$level = _ref.level,
      level = _ref$level === void 0 ? 1 : _ref$level,
      children = _ref.children,
      isLoading = _ref.isLoading,
      _ref$theme = _ref.theme,
      props = _objectWithoutProperties(_ref, _excluded);

  return isLoading ? /*#__PURE__*/React__default.createElement(headline_style.SkeletonWrapper, {
    level: level
  }, /*#__PURE__*/React__default.createElement(skeleton, {
    width: "100%",
    height: "100%"
  })) : /*#__PURE__*/React__default.createElement(headline_style.HeadlineWrapper, _extends({
    as: "h".concat(level) //TS can't type this `as` prop
    ,
    level: level
  }, props), children);
};

module.exports = Headline;
